/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import Spacing from '../Spacing';
import { pageTitle } from '../../helpers/PageTitle';
import { blogDetailById } from '../../service/api';
import dayjs from 'dayjs';
import { previewAssetUrl } from '../../helpers';

export default function BlogDetails() {
  const { blogId: id } = useParams();
  const [blog, setBlog] = useState(null);

  const fetchBlog = async () => {
    try {
      const res = await blogDetailById(id);
      setBlog(res.data);
    } catch (error) {
      setBlog(null);
    }
  };

  useEffect(() => {
    fetchBlog();
  }, [id]);

  pageTitle('Blog Details');
  return (
    <>
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={blog?.title || ''} />
      </Section>
      <div className='container'>
        <div className='cs_blog_details_info'>
          <div className='cs_blog_details_info_left flex items-center justify-between w-full'>
            <div className='cs_blog_details_tags'>
              {blog?.hashtag?.map((item, index) => (
                <Link key={index} to={item.href}>
                  {item}
                </Link>
              ))}
            </div>
            <div className='cs_blog_details_date'>
              {`${dayjs(blog?.createdAt).format('DD/MM/YYYY')}`}
            </div>
          </div>
        </div>
        <Spacing md='55' />
        <img
          src={previewAssetUrl(blog?.assetDetailId)}
          alt='Blog Details'
          className='w-100 cs_radius_20'
        />
        <Spacing md='90' lg='50' />
        <div className='row'>
          <div className='col-lg-12'>
            <div
              className='cs_blog_details'
              dangerouslySetInnerHTML={{
                __html: blog?.content,
              }}
            />
          </div>
        </div>
      </div>
      <Spacing md='200' xl='150' lg='110' />
    </>
  );
}
